(function () {
  const DESKTOP = window.matchMedia("(min-width: 990px)");

  function createPanel() {
    if (document.querySelector(".us-nav-panel")) return;

    const backdrop = document.createElement("div");
    backdrop.className = "us-nav-backdrop";

    const panel = document.createElement("div");
    panel.className = "us-nav-panel";
    panel.innerHTML = `
      <div class="us-nav-panel__header">
        <div class="us-nav-panel__title"></div>
        <button class="us-nav-panel__close" type="button" aria-label="Close menu">✕</button>
      </div>
      <div class="us-nav-panel__body"></div>
    `;

    document.body.appendChild(backdrop);
    document.body.appendChild(panel);

    function close() {
      backdrop.classList.remove("is-open");
      panel.classList.remove("is-open");
      document.body.classList.remove("body-lock-scroll");
      panel.querySelector(".us-nav-panel__title").textContent = "";
      panel.querySelector(".us-nav-panel__body").innerHTML = "";
    }

    backdrop.addEventListener("click", close);
    panel.querySelector(".us-nav-panel__close").addEventListener("click", close);

    document.addEventListener("keydown", (e) => {
      if (e.key === "Escape") close();
    });

    panel._usClose = close;
  }

  function openPanel(title, contentNode) {
    const panel = document.querySelector(".us-nav-panel");
    const backdrop = document.querySelector(".us-nav-backdrop");
    if (!panel || !backdrop) return;

    panel.querySelector(".us-nav-panel__title").textContent = title || "";
    const body = panel.querySelector(".us-nav-panel__body");
    body.innerHTML = "";

    // Clone content so we do not break the theme menu
    const clone = contentNode.cloneNode(true);
    body.appendChild(clone);

    backdrop.classList.add("is-open");
    panel.classList.add("is-open");
    document.body.classList.add("body-lock-scroll");
  }

  function findSubmenuFromDetails(detailsEl) {
    if (!detailsEl) return null;

    const selectors = [
      ".header-nav-desktop-dd-panel",
      ".mega-menu__content",
      ".header__submenu",
      ".menu-drawer",
      ".dropdown-panel",
      ".nav-dropdown",
      "[data-submenu]",
      "[role='menu']",
      "ul"
    ];

    for (const sel of selectors) {
      const found = detailsEl.querySelector(sel);
      if (found) return found;
    }

    // Fallback: first element after summary
    const summary = detailsEl.querySelector("summary");
    if (summary && summary.nextElementSibling) return summary.nextElementSibling;

    return null;
  }

  function bind() {
    createPanel();

    const header = document.querySelector("header") || document;
    header.addEventListener("click", (e) => {
      if (!DESKTOP.matches) return;

      // Target clicks on <summary> inside header nav
      const summary = e.target.closest("header summary");
      if (!summary) return;

      const details = summary.closest("details");
      if (!details) return;

      const submenu = findSubmenuFromDetails(details);
      if (!submenu) return;

      // Prevent the theme dropdown from opening
      e.preventDefault();
      e.stopPropagation();

      // Ensure the details does not stay open
      details.removeAttribute("open");

      const label =
        (summary.textContent || "")
          .replace(/\s+/g, " ")
          .trim();

      openPanel(label, submenu);
    }, true);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", bind);
  } else {
    bind();
  }
})();